import React from 'react';

const GameOver = ({ day, money, targetMoney }) => {
  return (
    <div style={{ padding: '50px', textAlign: 'center', fontFamily: 'sans-serif' }}>
      <h1 style={{ color: 'red', fontSize: '40px' }}>หมดเวลา! ร้านปิดแล้ว 😭</h1>
      <p style={{ fontSize: '20px' }}>คุณไปถึง <strong>วันที่ {day}</strong></p>
      <p style={{ fontSize: '20px' }}>ทำยอดขายรวมได้: ฿{money} (เป้าหมายสุดท้าย: ฿{targetMoney})</p>
      <button 
        onClick={() => window.location.reload()} 
        style={{ marginTop: '30px', padding: '15px 30px', fontSize: '18px', backgroundColor: '#2f3542', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer' }}
      >
        กลับสู่หน้าหลัก / เริ่มเกมใหม่
      </button>
    </div>
  );
};

export default GameOver;